import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["value"]

import { ref, computed, watch, reactive, onMounted } from 'vue';
import * as cidadeService from '@/services/cidadesService';

interface Props {
  modelValue?: number
  placeholder?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownCidadesAtiva',
  props: {
    modelValue: {},
    placeholder: {}
  },
  emits: ['update:modelValue', 'selected'],
  setup(__props: any, { emit: __emit }) {

var props = __props;
const emit = __emit


var controle = reactive({
  cidades: [] as cidadeService.Cidade[],
  cidadeId: null as number | null,
  text: "",
  status: ""
})

onMounted(() => {
  buscarCidades()
})



function selecionar() {
 
  var cidade =   controle.cidades.find(c => c.cidadeId === controle.cidadeId)
  if (cidade) {
    emit('update:modelValue', cidade.cidadeId)
    emit('selected', cidade)
  }
  else {
    emit('update:modelValue', null)
    emit('selected', null)
  }
}


// Watch para sincronizar com modelValue externo
watch<number | undefined>(() => props.modelValue, (newValue) => {
  controle.cidadeId = newValue ?? null;
})


function buscarCidades() {
  controle.status = "Buscando cidades...";

  cidadeService.obter({ativo:true, tamanhoPagina: 6000}).then(response => {
    controle.cidades = response;
    controle.status = "";
  }).catch(error => {
    console.error("Erro ao buscar cidades:", error);
    controle.status = `Erro ${error.message}`;
  })
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("select", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).cidadeId) = $event)),
    class: "form-select form-select-sm",
    onChange: _cache[1] || (_cache[1] = ($event: any) => (selecionar()))
  }, [
    _cache[2] || (_cache[2] = _createElementVNode("option", { value: null }, "- Selecione -", -1)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).cidades, (cidade) => {
      return (_openBlock(), _createElementBlock("option", {
        key: cidade.cidadeId,
        value: cidade.cidadeId
      }, _toDisplayString(cidade.nome) + " - " + _toDisplayString(cidade.estado), 9, _hoisted_1))
    }), 128))
  ], 544)), [
    [_vModelSelect, _unref(controle).cidadeId]
  ])
}
}

})